import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, Redirect } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider, Theme } from '@material-ui/core/styles';
import Login from './accounts/Login';
import ForgotPassword from './accounts/ForgotPassword';
import ResetPassword from './accounts/ResetPassword';
import SetupAccount from './accounts/SetupAccount';
import MainPage from './main-navigation/MainPage';
import RouterWithHistory from './RouterWithHistory';
import Routes from './Routes';
import NotificationsRenderer from './ui/Notifications';
import ConfirmationDialog, { confirmationModel } from './ui/ConfirmationDialog';
import { PrivateRoute } from './utility/PrivateRoute';
import createWorkSightBaseTheme from './WorkSightBaseTheme';
import { makeStyles } from './utility/styles';
import { Observe } from 'rewire-core';
import authService from './services/AuthService';

const theme = createWorkSightBaseTheme();

async function start() {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ConfirmationDialog viewModel={confirmationModel} />
      <NotificationsRenderer anchorHorizontal="right" anchorVertical="bottom" displayDuration={5_000} />
      <Main />
    </ThemeProvider>,
    document.getElementById('root'),
  );
}

const styles = (theme: Theme) => ({
  root: {
    height: '100%',
    color: theme.palette.neutral.main,
  },
});

const useMainStyles = makeStyles(styles);

function Main() {
  return (
    <Observe>
      {() => {
        const classes = useMainStyles();

        if (!authService.isAuthenticated && authService.isLoading) {
          return <div>LOADING...</div>;
        }

        return (
          <div id="application-root" className={classes.root}>
            <RouterWithHistory>
              <LastLocationProvider>
                <Switch>
                  <Route exact path={Routes.Login} component={Login} />
                  <Route exact path={Routes.ForgotPassword} component={ForgotPassword} />
                  <Route exact path={Routes.ResetPassword} component={ResetPassword} />
                  {/* <Route        exact path={Routes.Register}       component={Register} /> */}
                  <Route exact path={Routes.SetupAccount} component={SetupAccount} />
                  <PrivateRoute path={Routes.Home} component={MainPage} />
                  <Route path={Routes.Root}>
                    <Redirect to={Routes.Home} />
                  </Route>
                  {/* <Route              path={Routes.Root}           component={Landing} /> */}
                </Switch>
              </LastLocationProvider>
            </RouterWithHistory>
          </div>
        );
      }}
    </Observe>
  );
}

start();
